import { classNames } from '@vkontakte/vkjs';
import { Button, Caption, ColorSchemeProvider, Flex, Tappable } from '@vkontakte/vkui';
import { AudioWaveform } from '@dui/AudioWaveform/AudioWaveform';
import { useCheckDesktop } from '@dui/hooks';
import { MediaPlayerController } from '@dui/MediaPlayerController';
import { useVoiceMessage } from './useVoiceMessage';
import { statusIconMapper } from './const';
import styles from './MessageBubbleAttachVoice.module.css';

interface MessageBubbleAttachVoiceProps {
  /**
   * Контроллер воспроизведения нескольких голосовых
   */
  mediaPlayerController?: MediaPlayerController;
  /**
   * Ссылка на аудио
   */
  url: string;
  /**
   * Уникальный id, нужен для работы контроллера
   */
  mediaId: string;
  /**
   * Набор чисел для отображения волн голосоового
   */
  waveform: number[];
  /**
   * Максимальное значение в waveform
   */
  waveformMaxValue: number;
  /**
   * Длительность аудио в секундах
   */
  duration: number;
  className?: string;
}

export function MessageBubbleAttachVoice(props: MessageBubbleAttachVoiceProps) {
  const { mediaPlayerController, className, waveform, waveformMaxValue, url, mediaId, duration } = props;

  const isDesktop = useCheckDesktop();

  const {
    speed,
    togglePlaying,
    audioStatus,
    isTogglePlayingDisabled,
    isWaveformDisabled,
    timerRef,
    getProgressSetterRef,
    onProgressMoveStart,
    onProgressMove,
    onProgressMoveEnd,
    onSpeedClick,
  } = useVoiceMessage({ mediaPlayerController, url, mediaId, duration, commonSpeedControl: true });

  const Icon = statusIconMapper[20][audioStatus];

  return (
    <Flex className={classNames(styles.root, className)} align="center" gap={8} noWrap>
      <Tappable
        data-testid={`voice-action-${audioStatus}`}
        disabled={isTogglePlayingDisabled}
        onClick={togglePlaying}
        className={classNames(styles.button, styles[`button__${audioStatus}`])}
      >
        <Icon />
      </Tappable>
      <div className={styles.wrapper}>
        <div className={styles.row}>
          <div className={styles.overflow}>
            <AudioWaveform
              isInteractDisabled={isWaveformDisabled}
              color="var(--message-bubble-color-voice-wave)"
              waveform={waveform}
              waveformMaxValue={waveformMaxValue}
              className={styles.overflow}
              getProgressSetterRef={getProgressSetterRef}
              onProgressMoveStart={onProgressMoveStart}
              onProgressMove={onProgressMove}
              onProgressMoveEnd={onProgressMoveEnd}
            />
          </div>
          <ColorSchemeProvider value="dark">
            <Button
              data-testid="voice-speed"
              hoverMode="opacity"
              activeMode="opacity"
              className={styles.speed}
              onClick={onSpeedClick}
              size="s"
            >
              <Caption>{speed}x</Caption>
            </Button>
          </ColorSchemeProvider>
        </div>
        <Flex align="center" justify="space-between">
          <Caption
            data-testid="voice-timer"
            className={classNames(styles.caption, !isDesktop && styles.caption__lower)}
            level="2"
            getRootRef={timerRef}
          />
        </Flex>
      </div>
    </Flex>
  );
}
